import React from 'react'
import {CondominiumInfo} from '../../condominium/repository/NatGetCondominiumList'
import {TableCell, TableRow} from '@mui/material'
import styled from 'styled-components'
import {PREFECTURES_MASTER, SELECT_CONDOMINIUM_TYPE, VALID_OR_NOT_CHECK} from '../../../../CodeMaster'
import {formatDateTimeForUpdateDate} from '../../../../formatters/formatDate'
import {AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'

interface Props {
    selectCondominiumType: string
    unreleaseCondominiumExclusionFlg?: boolean
    condominium: CondominiumInfo
    isExcludeCondominium: boolean
    updateSelectedCondominiumInfo: (selectedCondominiumInfo: CondominiumInfo) => void
    onClickOperationButton: (selectedCondominiumInfo: CondominiumInfo) => void
}

const NatAdminCondominiumSelectionRecode: React.FC<Props> = React.memo(props => {
    const {
        selectCondominiumType,
        unreleaseCondominiumExclusionFlg,
        condominium,
        isExcludeCondominium,
        updateSelectedCondominiumInfo,
        onClickOperationButton
    } = props

    return (
        <SelectedCondominiumTableRow
            key={condominium.condominiumCd}
            $selectedFlg={isExcludeCondominium}>
            <TableCell align={'left'}>{condominium.condominiumCd}</TableCell>
            <TableCell align={'left'}>{condominium.condominiumName}</TableCell>
            <TableCell align={'left'}>{condominium.condominiumGroupName}</TableCell>
            {selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                <>
                    <TableCell align={'left'}>
                        {PREFECTURES_MASTER.codeToEnumConstants(condominium.prefectureCd).label}
                    </TableCell>
                    <TableCell align={'left'}>
                        {condominium.address2}
                    </TableCell>
                </>
            }
            <TableCell align={'left'}>{formatDateTimeForUpdateDate(condominium.updateDatetime)}</TableCell>
            {!unreleaseCondominiumExclusionFlg &&
                <TableCell align={'center'}>
                    {VALID_OR_NOT_CHECK.codeToEnumConstants(condominium.releaseFlg).label}
                </TableCell>
            }
            {selectCondominiumType === SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value &&
                <TableCell align={'center'}>
                    <AdminPrimaryButton onClick={() => onClickOperationButton(condominium)}
                    >
                        {isExcludeCondominium ? '解除' : '選択'}
                    </AdminPrimaryButton>
                </TableCell>
            }

            {selectCondominiumType === SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value &&
                <TableCell align={'center'}>
                    <AdminPrimaryButton onClick={() => updateSelectedCondominiumInfo(condominium)}>
                        選択
                    </AdminPrimaryButton>
                </TableCell>
            }
        </SelectedCondominiumTableRow>
    )
})

interface SelectedCondominium {
    $selectedFlg: boolean
}

const SelectedCondominiumTableRow = styled(TableRow)<SelectedCondominium>`
    ${props => props.$selectedFlg ? ` &.MuiTableRow-root {
      background-color: #b2b9e1;
   }` : ``}

    ${props => props.$selectedFlg ? ` &.MuiTableRow-root button {
      background-color: #afabab;
   }` : ``}
`

NatAdminCondominiumSelectionRecode.displayName = 'NatAdminCondominiumSelectionRecode'
export default NatAdminCondominiumSelectionRecode